import React, { useState } from 'react';
import style from './TextContent.module.css';

const TextContent = () => {
  const [readMore, setReadMore] = useState(false);

  const handleReadMore = () => setReadMore(r => !r);

  return (
    <div className={style.TextContent}>
      <h1 className={style.mainHeading}>KARTIK MASS | ISKCON Vijayawada</h1>

      <p className={style.patagContent}>
        Kartika month is the most beloved month of Lord Krishna, a time when every act of devotion multiplies a thousandfold. This year, the auspicious month of Kartika will be observed from 7th October to 5th November. It is the perfect opportunity to offer your loving service to Sri Krishna, His devotees, and Gaumata.
      </p>

      <div
        className={`${style.collapsible} ${readMore ? style.open : ''}`}
        aria-hidden={!readMore}
      >
        <p className={style.patagContent}>
          As the Padma Purana says, “Even offering a single lamp during Kartika pleases Lord Krishna immensely.” By participating in devotional services during this sacred month, a devotee is blessed with peace, prosperity, and divine happiness.
        </p>

        <p className={style.patagContent}>
          At ISKCON Vijayawada, the temple is beautifully decorated every day with thousands of lamps, spreading a divine radiance that touches every heart. You are warmly invited to join in the Deepa Dana Seva, contributing to this spiritual illumination and helping elevate the temple’s sacred ambiance.
        </p>

        <p className={style.patagContent}>
          This Kartika, you can also extend your devotion through Annadana (feeding devotees), Go-Seva (service to cows), Pushpalankara Seva (offering flowers to the Lord), and Vishesha Naivedya Seva (offering special food to Krishna). By sponsoring these services, you receive not only the Lord’s blessings but also special prasadam delivered to your home.
        </p>

        <p className={style.patagContent}>
          Embrace this divine opportunity and make your Kartika month at ISKCON Vijayawada a time of blessings, joy, and spiritual growth. Serve with love, and experience the boundless mercy and bliss of Lord Krishna.
        </p>
      </div>

      <button
        className={`${style.readMoreBtn} ${readMore ? style.active : ''}`}
        onClick={handleReadMore}
        aria-expanded={readMore}
      >
        {readMore ? 'Read Less' : 'Read More'}
      </button>

      <h2 className={style.FHheading}>Festival Highlights</h2>
    </div>
  );
};

export default TextContent;
